<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p10
        target group
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p10" title="mthfr-p10">
    <img-card>
      <div slot="title" style="width:100%;">{{$t('Mthfr.P10_Title')}}</div>
      
      <div class="content">
        <div class="box">
          <img src="../../../assets/images/mthfr/p10-1.png">
          <div class="info">{{$t('Mthfr.P10_1')}}</div>
        </div>
        <div class="box">
          <img src="../../../assets/images/mthfr/p10-2.png">
          <div class="info">{{$t('Mthfr.P10_2')}}</div>
        </div>
        <div class="box">
          <img src="../../../assets/images/mthfr/p10-3.png">
          <div class="info">{{$t('Mthfr.P10_3')}}</div>
        </div>
        <div class="box">
          <img src="../../../assets/images/mthfr/p10-4.png">
          <div class="info">{{$t('Mthfr.P10_4')}}</div>
        </div>
        <div class="box">
          <img src="../../../assets/images/mthfr/p10-5.png">
          <div class="info">{{$t('Mthfr.P10_5')}}</div>
        </div>
      </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p10",
    components: {ImgCard}
  }
</script>

<style  lang="scss">
  .v-mthfr-p10 {

    .content{
      display: flex;
      justify-content: space-between;
      .box{
        flex-shrink: 0;
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 20%;

        &:first-child{
          padding-left: 0;
        }
        &:last-child{
          padding-right: 0;
        }
        img{
          width: 70px;
          height: 70px;
        }
        .info{
          padding: 0 12px;
          margin-top: 18px;
          color: #010101;
          text-align: center;
        }
      }
    }

  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p10.vue